import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTRSRegistration } from '@/API/TRSRegistration/createTRSRegistration';

/**
 * Custom hook to create a new AOR
 * This simulates API calls with mock data for now
 */
const useCreateAOR = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (newAorData) => {
            try {
                const response = await createTRSRegistration({
                    ...newAorData,
                    isEnabled: true,
                });

                return response.data;
            } catch (error) {
                console.error('Failed to create TRS Registration:', error);
                throw error;
            }
        },
        onSuccess: (data) => {
            // Add the new record on top of existing table data (preserving static data)
            queryClient.setQueryData(['TRSRegistrations'], (oldData) => {
                if (!oldData) return [data];
                return [data, ...oldData]; // Add new record on top
            });

            // Invalidate and refetch AORs to ensure consistency
            queryClient.invalidateQueries(['TRSRegistrations']);

            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            console.error('Failed to create AOR:', error);
            if (onError) {
                onError(error);
            }
        },
    });

    return mutation;
};

export default useCreateAOR;
